import {
	FETCH_ATELIERMODELE_BEGIN,
	FETCH_ATELIERMODELE_SUCCESS,
	FETCH_ATELIERMODELE_ERROR,
	FETCH_ATELIERMODELE_RESET,
	POST_ATELIERMODELE_BEGIN,
	POST_ATELIERMODELE_ERROR,
	POST_ATELIERMODELE_SUCCESS,
	POST_ATELIERMODELE_RESET,
	POST_ATELIERMODELE_ERRORFIELD,
	DELETE_ATELIERMODELE_BEGIN,
	DELETE_ATELIERMODELE_ERROR,
	DELETE_ATELIERMODELE_RESET,
	DELETE_ATELIERMODELE_SUCCESS,
	FETCH_ATELIERMODELES_BEGIN,
	FETCH_ATELIERMODELES_SUCCESS,
	FETCH_ATELIERMODELES_ERROR,
	FETCH_ATELIERMODELES_RESET,
	FETCH_ATELIERLIGNEMODELE_BEGIN,
	FETCH_ATELIERLIGNEMODELE_ERROR,
	FETCH_ATELIERLIGNEMODELE_RESET,
	FETCH_ATELIERLIGNEMODELE_SUCCESS,
	FETCH_ATELIERCOMMENTAIREMODELE_BEGIN,
	FETCH_ATELIERCOMMENTAIREMODELE_ERROR,
	FETCH_ATELIERCOMMENTAIREMODELE_RESET,
	FETCH_ATELIERCOMMENTAIREMODELE_SUCCESS,
} from "../actions/atelierModeleActions"

const initialState = {
	atelierModele: {
		id: Math.random() * 1000,
		nom: "",
		svp: false,
		nbHeures: 0,
		isForfait: false,
		total: 0,
	},
	atelierLigneModele: [],
	atelierCommentaireModele: [],
	listeAtelierModeles: [],
	fetchAtelierModele: {
		loading: false,
		error: false,
	},
	postAtelierModele: {
		saving: false,
		saved: false,
		error: false,
		errorFields: [],
	},
	fetchAtelierModeles: {
		loading: false,
		error: false,
	},
	fetchAtelierLigneModele: {
		loading: false,
		error: false,
	},
	fetchAtelierCommentaireModele: {
		loading: false,
		error: false,
	},
	deleteAtelierModele: {
		deleting: false,
		deleted: false,
		error: false,
	},
}

export default function atelierModeleReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_ATELIERMODELE_BEGIN:
			return {
				...state,
				fetchAtelierModele: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIERMODELE_ERROR:
			return {
				...state,
				fetchAtelierModele: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIERMODELE_RESET:
			return {
				...state,
				atelierModele: {
					id: Math.random() * 1000,
					nom: "",
					svp: false,
					nbHeures: 0,
					isForfait: false,
					total: 0,
				},
				atelierLigneModele: [],
				atelierCommentaireModele: [],
			}
		case FETCH_ATELIERMODELE_SUCCESS:
			return {
				...state,
				atelierModele: action.payload.am,
				atelierLigneModele: action.payload.aml,
				atelierCommentaireModele: action.payload.amc,
				fetchAtelierModele: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIERLIGNEMODELE_BEGIN:
			return {
				...state,
				fetchAtelierLigneModele: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIERLIGNEMODELE_ERROR:
			return {
				...state,
				fetchAtelierLigneModele: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIERLIGNEMODELE_RESET:
			return {
				...state,
				fetchAtelierLigneModele: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIERLIGNEMODELE_SUCCESS:
			return {
				...state,
				atelierLigneModele: action.payload.atelierLigneModele,
				fetchAtelierLigneModele: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIERCOMMENTAIREMODELE_BEGIN:
			return {
				...state,
				fetchAtelierCommentaireModele: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIERCOMMENTAIREMODELE_ERROR:
			return {
				...state,
				fetchAtelierCommentaireModele: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIERCOMMENTAIREMODELE_RESET:
			return {
				...state,
				fetchAtelierCommentaireModele: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIERCOMMENTAIREMODELE_SUCCESS:
			return {
				...state,
				atelierCommentaireModele:
					action.payload.atelierCommentaireModele,
				fetchAtelierCommentaireModele: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIERMODELES_BEGIN:
			return {
				...state,
				fetchAtelierModeles: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIERMODELES_ERROR:
			return {
				...state,
				fetchAtelierModeles: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIERMODELES_RESET:
			return {
				...state,
				listeAtelierModeles: [],
				fetchAtelierModeles: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIERMODELES_SUCCESS:
			return {
				...state,
				listeAtelierModeles: action.payload.listeAtelierModeles,
				fetchAtelierModeles: {
					loading: false,
					error: false,
				},
			}
		case POST_ATELIERMODELE_BEGIN:
			return {
				...state,
				postAtelierModele: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIERMODELE_ERROR:
			return {
				...state,
				postAtelierModele: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_ATELIERMODELE_SUCCESS:
			return {
				...state,
				atelierModele: action.payload.atelier,
				atelierLigneModele: action.payload.atelierLignes,
				atelierCommentaireModele: action.payload.atelierCommentaires,
				postAtelierModele: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIERMODELE_RESET:
			return {
				...state,
				postAtelierModele: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIERMODELE_ERRORFIELD:
			return {
				...state,
				postAtelierModele: {
					saved: false,
					saving: false,
					error: false,
					errorFields: action.payload.errorFields,
				},
			}
		// DELETE ATELIERMODELE
		case DELETE_ATELIERMODELE_BEGIN:
			return {
				...state,
				deleteAtelierModele: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_ATELIERMODELE_ERROR:
			return {
				...state,
				deleteAtelierModele: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_ATELIERMODELE_SUCCESS:
			return {
				...state,
				listeAtelierModeles: action.payload.listeAtelierModeles,
				deleteAtelierModele: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_ATELIERMODELE_RESET:
			return {
				...state,
				deleteAtelierModele: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		case "REORDER_ALIGNES_MODELE":
			let dragIndex = state.atelierLigneModele.findIndex(
				(aL) => aL.id === action.dragId,
			)
			let dropIndex = state.atelierLigneModele.findIndex(
				(aL) => aL.id === action.dropId,
			)
			if (dragIndex < dropIndex) {
				return {
					...state,
					atelierLigneModele: [
						...state.atelierLigneModele.slice(0, dragIndex),
						...state.atelierLigneModele.slice(
							dragIndex + 1,
							dropIndex + 1,
						),
						state.atelierLigneModele[dragIndex],
						...state.atelierLigneModele.slice(dropIndex + 1),
					],
				}
			} else if (dragIndex > dropIndex) {
				return {
					...state,
					atelierLigneModele: [
						...state.atelierLigneModele.slice(0, dropIndex),
						state.atelierLigneModele[dragIndex],
						...state.atelierLigneModele.slice(dropIndex, dragIndex),
						...state.atelierLigneModele.slice(dragIndex + 1),
					],
				}
			} else {
				return {
					...state,
				}
			}
		case "REORDER_ACOMS_MODELE":
			let dragIndex2 = state.atelierCommentaireModele.findIndex(
				(aL) => aL.id === action.dragId,
			)
			let dropIndex2 = state.atelierCommentaireModele.findIndex(
				(aL) => aL.id === action.dropId,
			)
			if (dragIndex2 < dropIndex2) {
				return {
					...state,
					atelierCommentaireModele: [
						...state.atelierCommentaireModele.slice(0, dragIndex2),
						...state.atelierCommentaireModele.slice(
							dragIndex2 + 1,
							dropIndex2 + 1,
						),
						state.atelierCommentaireModele[dragIndex2],
						...state.atelierCommentaireModele.slice(dropIndex2 + 1),
					],
				}
			} else if (dragIndex2 > dropIndex2) {
				return {
					...state,
					atelierCommentaireModele: [
						...state.atelierCommentaireModele.slice(0, dropIndex2),
						state.atelierCommentaireModele[dragIndex2],
						...state.atelierCommentaireModele.slice(
							dropIndex2,
							dragIndex2,
						),
						...state.atelierCommentaireModele.slice(dragIndex2 + 1),
					],
				}
			} else {
				return {
					...state,
				}
			}
		case "UPDATE_ATELIERMODELE":
			return {
				...state,
				atelierModele: action.value,
			}
		case "UPDATE_ATELIERLIGNEMODELE":
			let almIndex = state.atelierLigneModele.findIndex(
				(alm) => alm.id === action.value.id,
			)
			if (almIndex !== -1) {
				return {
					...state,
					atelierLigneModele: [
						...state.atelierLigneModele.slice(0, almIndex),
						action.value,
						...state.atelierLigneModele.slice(almIndex + 1),
					],
				}
			} else {
				return {
					...state,
					atelierLigneModele: [
						...state.atelierLigneModele,
						action.value,
					],
				}
			}
		case "REMOVE_ATELIERLIGNEMODELE":
			return {
				...state,
				atelierLigneModele: state.atelierLigneModele.filter(
					(al) => al.id !== action.value,
				),
			}
		case "UPDATE_ATELIERCOMMENTAIREMODELE":
			let alcIndex = state.atelierCommentaireModele.findIndex(
				(alm) => alm.id === action.value.id,
			)
			if (alcIndex !== -1) {
				return {
					...state,
					atelierCommentaireModele: [
						...state.atelierCommentaireModele.slice(0, alcIndex),
						action.value,
						...state.atelierCommentaireModele.slice(alcIndex + 1),
					],
				}
			} else {
				return {
					...state,
					atelierCommentaireModele: [
						...state.atelierCommentaireModele,
						action.value,
					],
				}
			}
		case "REMOVE_ATELIERCOMMENTAIREMODELE":
			return {
				...state,
				atelierCommentaireModele: state.atelierCommentaireModele.filter(
					(al) => al.id !== action.value,
				),
			}
		default:
			return state
	}
}
